import Card from '@mui/material/Card/Card';
import styled from 'styled-components';
import { reemaColors } from 'toolkit/styles/colors';
import TabbedPanel from 'toolkit/tabs/tabbedPanel';
import CallsIndex from './calls-index/calls-index';
import TextsIndex from './texts-index/text-index';
import { useState } from 'react';
import { AppHeaderPortal } from '@act/storybook';
import { Box, Typography } from '@mui/material';
import TranscriptionDrawerContext from 'react-components/member-page/post-call-summary-drawer/PostCallSummaryContext';

const CallsPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const TabbedPanelContainer = styled(Card)`
  padding: 8px 0 0;
  border-radius: 8px;
  background-color: ${reemaColors.lightBackground};
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

const CallsPage = () => {
  const [currentTabKey, setCurrentTabKey] = useState<string>('calls-tab');
  const [voiceCallId, setVoiceCallId] = useState<number | null>(null);

  return (
    <TranscriptionDrawerContext.Provider
      value={{ voiceCallId, isReadOnly: true, setVoiceCallId }}
    >
      <CallsPageContainer>
        <TabbedPanelContainer>
          <TabbedPanel
            setCurrentTabKey={setCurrentTabKey}
            tabDefinitions={[
              {
                key: 'calls-tab',
                label: 'Calls',
                component: (
                  <CallsIndex active={currentTabKey === 'calls-tab'} />
                ),
              },
              {
                key: 'texts-tab',
                label: 'Texts',
                component: (
                  <TextsIndex active={currentTabKey === 'texts-tab'} />
                ),
              },
            ]}
          />
        </TabbedPanelContainer>
      </CallsPageContainer>
      <AppHeaderPortal>
        <Box padding="0 16px">
          <Typography color="primary" variant="titleLarge">
            Calls and texts
          </Typography>
        </Box>
      </AppHeaderPortal>
    </TranscriptionDrawerContext.Provider>
  );
};

export default CallsPage;
